import './seat-plan.css';

import * as React from 'react';
import axios from 'axios';
import { Translate, translate } from 'react-jhipster';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Table, Label, Alert, Row, Col } from 'reactstrap';

const seatPlans = {
  STALLS: require('../../../static/site/macpherson-v2/STALLS.json'),
  '1 SECTION': require('../../../static/site/macpherson-v2/1SECTION.json'),
  '2 SECTION': require('../../../static/site/macpherson-v2/2SECTION.json'),
  '3 SECTION': require('../../../static/site/macpherson-v2/3SECTION.json'),
  '7 SECTION': require('../../../static/site/macpherson-v2/7SECTION.json'),
  '8 SECTION': require('../../../static/site/macpherson-v2/8SECTION.json'),
  '9 SECTION': require('../../../static/site/macpherson-v2/9SECTION.json'),
  '10 SECTION': require('../../../static/site/macpherson-v2/10SECTION.json'),
  '11 SECTION': require('../../../static/site/macpherson-v2/11SECTION.json'),
  '12 SECTION': require('../../../static/site/macpherson-v2/12SECTION.json'),
  F01: require('../../../static/site/broadway-macau/F01.json'),
  F02: require('../../../static/site/broadway-macau/F02.json'),
  F03: require('../../../static/site/broadway-macau/F03.json'),
  '101': require('../../../static/site/broadway-macau/101.json'),
  '102': require('../../../static/site/broadway-macau/102.json'),
  '103': require('../../../static/site/broadway-macau/103.json'),
  '105': require('../../../static/site/broadway-macau/105.json'),
  '106': require('../../../static/site/broadway-macau/106.json'),
  M01: require('../../../static/site/broadway-macau/M01.json'),
  M02: require('../../../static/site/broadway-macau/M02.json'),
  M03: require('../../../static/site/broadway-macau/M03.json'),
  M05: require('../../../static/site/broadway-macau/M05.json'),
  M06: require('../../../static/site/broadway-macau/M06.json'),
  '201': require('../../../static/site/broadway-macau/201.json'),
  '202': require('../../../static/site/broadway-macau/202.json'),
  '203': require('../../../static/site/broadway-macau/203.json'),
  '205': require('../../../static/site/broadway-macau/205.json'),
  'SECTION 101': require('../../../static/site/macau-arena/101.json'),
  'SECTION 102': require('../../../static/site/macau-arena/102.json'),
  'SECTION 121': require('../../../static/site/macau-arena/121.json'),
  'SECTION 123': require('../../../static/site/macau-arena/123.json'),
  'SECTION 124': require('../../../static/site/macau-arena/124.json'),
  'SECTION 218': require('../../../static/site/macau-arena/218.json'),
  'SECTION F301': require('../../../static/site/macau-arena/F301.json'),
  'SECTION 1-1': require('../../../static/site/kitec/SECTION1-1.json'),
  'SECTION 1-2': require('../../../static/site/kitec/SECTION1-2.json'),
  'SECTION 2-1': require('../../../static/site/kitec/SECTION2-1.json'),
  'SECTION 2-2': require('../../../static/site/kitec/SECTION2-2.json'),
  STALL: require('../../../static/site/youth-square/STALL.json'),
  BALCONY: require('../../../static/site/youth-square/BALCONY.json')
};

export interface ISeatPlanModalState {
  seatPlan: any[];
}

export interface ISeatPlanModalProps {
  showModal: boolean;
  tickets: any[];
  handleClose: Function;
  zoneName: string;
}

class SeatPlanModal extends React.Component<ISeatPlanModalProps, ISeatPlanModalState> {
  state: ISeatPlanModalState = {
    seatPlan: []
  };

  /*
    componentDidMount() {
      axios
        .get('/static/images/3-tonick/stalls.json') // JSON File Path
        .then(response => {
          this.setState({ seatPlan: response.data.seatPlan });
        });
    }*/

  render() {
    const { handleClose } = this.props;

    const getTd = (seatPlanRow, seat, index) => {
      const seatInfo = seat.split(',');
      const className = [''];

      // cell default background color
      if (seatInfo[0] === '') className.push('border-0 empty');
      else className.push('sold');

      // cell selected color, set color/number only for assigned seat
      if (seatInfo.length > 1) className.push('p_' + seatInfo[1]);
      if (this.props.tickets.length === 0) {
        return (
          <td key={index} className={className.join(' ')}>
            {seatInfo[0] === '' ? '' : seatInfo[0]}
          </td>
        );
      } else {
        const isSelected = this.props.tickets.findIndex(t => t.row === seatPlanRow.row && t.displaySeat + '' === seatInfo[0]) > -1;
        if (isSelected) className.push('selected');
        return (
          <td key={index} className={className.join(' ')}>
            {isSelected ? seatInfo[0] : seatInfo[0] === '' ? '' : 'X'}
          </td>
        );
      }
    };

    return (
      <Modal isOpen={this.props.showModal} toggle={handleClose} backdrop="static" id="login-page" autoFocus={false} className="seat-plan">
        <ModalHeader id="seat-plan" toggle={handleClose}>
          <Translate contentKey="order.seatplan.seatplan">Seat Plan</Translate>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md="12">
              <div className="stageTop text-center">
                <div className="demo selected">&nbsp;</div>
                <span className="ml-2 mr-2">已派座位</span>
                <div className="demo sold">&nbsp;</div>
                <span className="ml-2 mr-2">不適用</span>
                <br />
                <br />
                Stage 舞台
              </div>
              <Table bordered responsive className="seat-plan">
                <tbody>
                  {this.props.zoneName !== '' &&
                    seatPlans[this.props.zoneName].seatPlan.map(seatPlanRow => (
                      <tr key={seatPlanRow.row}>
                        <td className="border-0 text-white">{seatPlanRow.row}</td>
                        {seatPlanRow.seats.map((seat, i) => getTd(seatPlanRow, seat, i))}
                      </tr>
                    ))}
                </tbody>
              </Table>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    );
  }
}

export default SeatPlanModal;
